import { render, staticRenderFns } from "./folderFavourites.vue?vue&type=template&id=a52c6ff2&scoped=true&"
import script from "./folderFavourites.vue?vue&type=script&lang=js&"
export * from "./folderFavourites.vue?vue&type=script&lang=js&"
import style0 from "./folderFavourites.vue?vue&type=style&index=0&id=a52c6ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c6ff2",
  null
  
)

export default component.exports